import { Companion_getInstance1gf57apoj2u0h as Companion_getInstance } from '../type/GraphQLBoolean.mjs';
import {
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance_0 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SaveBoostMutationSelectionsClass;
function SaveBoostMutationSelections() {
  if (SaveBoostMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        SaveBoostMutationSelections_instance = this;
        this.f6g_1 = listOf((new (Builder())('saveBoost', Companion_getInstance().f6o_1)).r43(listOf((new (Builder_0())(Companion_getInstance_0().n6d_1)).c44(new (CompiledVariable())('input')).i37())).i37());
      }
    }
    initMetadataForObject($, 'SaveBoostMutationSelections');
    SaveBoostMutationSelectionsClass = $;
  }
  return SaveBoostMutationSelectionsClass;
}
var SaveBoostMutationSelections_instance;
function SaveBoostMutationSelections_getInstance() {
  if (SaveBoostMutationSelections_instance === VOID)
    new (SaveBoostMutationSelections())();
  return SaveBoostMutationSelections_instance;
}
//region block: exports
export {
  SaveBoostMutationSelections_getInstance as SaveBoostMutationSelections_getInstance1exiso4dqvyol,
};
//endregion

//# sourceMappingURL=SaveBoostMutationSelections.mjs.map
